const VcomSetupEvent = {
  BASE_INIT_DONE: 'VcomSetupBaseInitDone',
};

export default VcomSetupEvent;
